export default  [
 
    {
    id: '1',
    icon: 'https://cdn.sushi.com/image/upload/f_auto,c_limit,w_64,q_auto/tokens/1/0xcAaa93712BDAc37f736C323C93D4D5fDEFCc31CC.jpg',
    symbol: 'CRD',
    name: 'CRD Network',
    decimals: '18',
    address: '0xcAaa93712BDAc37f736C323C93D4D5fDEFCc31CC', 
    vesting_period: '24 Months',
    explorer: 'https://etherscan.io/', 
    network: "Ethereum", 
    display_price: "0.05",
    exchange_rate: '0.05', 
    initial_price: "0.000056",
    coinmarketcap: "https://coinmarketcap.com/currencies/crdnetwork/", 
  }, 
  {
    id: '2',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33533.png',
    symbol: 'GOLDN',
    name: 'GoLondon',
    decimals: '18',
    address: '0xfE402841227213aDeBd67eC42921bf7b76415F6C', 
    vesting_period: '24 Months',
    explorer: 'https://etherscan.io/', 
    network: "Ethereum", 
    display_price: '0.0...45',
    exchange_rate: '0.0000045', 
    initial_price: "0.000001388",
    coinmarketcap: "https://coinmarketcap.com/currencies/golondon/", 
  },  
  {
    id: '3',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33409.png',
    symbol: 'STI',
    name: 'STI6900',
    decimals: '18',
    address: '0x518c54fDC12bA593617160eca423F4c2cd3ecac3', 
    vesting_period: '24 Months',
    explorer: 'https://etherscan.io/', 
    network: "Ethereum", 
    display_price: '0.0...31',
    exchange_rate: '0.000000003', 
    initial_price: "0.00000000007759",
    coinmarketcap: "https://coinmarketcap.com/currencies/sti6900/", 
  },  
  {
    id: '4',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33367.png',
    symbol: 'TURBO',
    name: 'Turbo Browser',
    decimals: '18',
    address: '0x78e927FcFB062599D8295163F0808A6FCDa7DB24', 
    vesting_period: '24 Months',
    explorer: 'https://etherscan.io/', 
    network: "Ethereum", 
    display_price: '0.0191', 
    exchange_rate: '0.0191', 
    initial_price: "0.006658",
    coinmarketcap: "https://coinmarketcap.com/currencies/turbo-browser/", 
  }, 
  {
    id: '5',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33588.png',
    symbol: 'WhyCat',
    name: 'WhyCat',
    decimals: '9',
    address: '0x2E16C912164B74830Be850cce9AF856797D21237', 
    vesting_period: '24 Months',
    explorer: 'https://etherscan.io/', 
    network: "Ethereum", 
    display_price: '0.0...15', 
    exchange_rate: '0.00000015', 
    initial_price: "0.00000004764",
    coinmarketcap: "https://coinmarketcap.com/currencies/whycat/", 
  }, 
  {
    id: '6',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/32844.png',
    symbol: 'WIWI',
    name: 'Wiggly Willy',
    decimals: '18',
    address: '0x181f2cBDa1AD44De56bAacBb41c8Fe448a2036fe', 
    vesting_period: '24 Months',
    explorer: 'https://etherscan.io/', 
    network: "Ethereum", 
    display_price: '0.0...32', 
    exchange_rate: '0.000000032', 
    initial_price: "0.00000001056",
    coinmarketcap: "https://coinmarketcap.com/currencies/wiggly-willy/", 
  }, 
  {
    id: '7',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33662.png',
    symbol: 'CRIPPL',
    name: 'Wheelchair Cat',
    decimals: '18',
    address: '0xBb712C77b69256934cDf2f630a2317ac82570388', 
    vesting_period: '24 Months',
    explorer: 'https://etherscan.io/', 
    network: "Ethereum", 
    display_price: '0.0...34', 
    exchange_rate: '0.000034', 
    initial_price: "0.00001095",
    coinmarketcap: "https://coinmarketcap.com/currencies/wiggly-willy/", 
  }, 
  {
    id: '8',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33365.png',
    symbol: 'GM',
    name: 'GM',
    decimals: '10',
    address: '0x89C1DA46D692D09814a88a27270D0DCa21e4734d', 
    vesting_period: '24 Months',
    explorer: 'https://etherscan.io/', 
    network: "Ethereum", 
    display_price: '0.0...15', 
    exchange_rate: '0.0000000015', 
    initial_price: "0.0000000002991",
    coinmarketcap: "https://coinmarketcap.com/currencies/gm-ether-frens/", 
  }, 
  {
    id: '9',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33506.png',
    symbol: 'VAULT',
    name: 'MoonVault',
    decimals: '18',
    address: '0x220125AF9DA649e368813733eC8702A4145F996b', 
    vesting_period: '24 Months',
    explorer: 'https://etherscan.io/', 
    network: "Ethereum", 
    display_price: '0.0...51', 
    exchange_rate: '0.000051', 
    initial_price: "0.00001589",
    coinmarketcap: "https://coinmarketcap.com/currencies/moonvault/", 
  }, 
  {
    id: '10',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33379.png',
    symbol: 'FOXXY',
    name: 'FOXXY',
    decimals: '18',
    address: '0x17b51b1DA73A02DB9dC20A71684Dc3EA70A0Dded', 
    vesting_period: '24 Months',
    explorer: 'https://etherscan.io/', 
    network: "Ethereum", 
    display_price: '0.0...59',
    exchange_rate: '0.00000059', 
    initial_price: "0.000000175",
    coinmarketcap: "https://coinmarketcap.com/currencies/foxxy/", 
  },
  {
    id: '11',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/33332.png',
    symbol: 'LEN',
    name: 'Len Sassaman',
    decimals: '9',
    address: '0xD0b0e54ebe7f450BE3f1b438E45b95d0eC6F9BD7', 
    vesting_period: '24 Months',
    explorer: 'https://etherscan.io/', 
    network: "Ethereum", 
    display_price: '0.0038',
    exchange_rate: '0.0038', 
    initial_price: "0.001238",
    coinmarketcap: "https://coinmarketcap.com/currencies/len-sassaman-ethereum/", 
  },
  {
    id: '12',
    icon: 'https://s2.coinmarketcap.com/static/img/coins/64x64/32604.png',
    symbol: 'BabyNeiro',
    name: 'Baby Neiro Coin',
    decimals: '9',
    address: '0xE9B8c15cB7C669c3f2679739c7835c6B911dbDDb', 
    vesting_period: '24 Months',
    explorer: 'https://etherscan.io/',
    network: "Ethereum",
    display_price: "0.0...98",
    exchange_rate: '0.000000098',
    initial_price: "0.00000002702",
    coinmarketcap: "https://coinmarketcap.com/currencies/baby-neiro-coin/"
  }, 
];


